import React from "react"

import { makeStyles } from "@material-ui/core/styles"

import payAnyDayLogo from '../../../images/logos/PayAnyDay/payanyday_logo_back2.jpg';


interface Props {
  size?: number | string
  width?: number | string
  height?: number | string
}

export const useStyles = makeStyles({
  logo: (props: Props) => ({
    maxWidth: props.width || props.size || "100%",
    maxHeight: props.height || props.size || "100%",
  }),
})

const Logo: React.FC<Props> = (props: Props) => {
  const classes = useStyles(props)
  return <img src={payAnyDayLogo} className={classes.logo} />
}

export default Logo
